import { render, staticRenderFns } from "./BoardEditForm.vue?vue&type=template&id=0bf8f836&"
import script from "./BoardEditForm.vue?vue&type=script&lang=js&"
export * from "./BoardEditForm.vue?vue&type=script&lang=js&"
import style0 from "./BoardEditForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports